import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeInUnits'
})
export class TimeInUnitsPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value >= 24 * 60 * 60) {
      return Math.floor((value/(24 * 60 * 60))) + 'd';
    }/*
    if (value >= 60 * 60) {
      return Math.floor(value/3600) + ' h';
    }
    if (value >= 60) {
      return Math.floor(value/60) + ' m';
    }*/
    return 'Today';
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/time-in-units.pipe.ts